import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './RecommendationCards.module.css';
import { executeWorkflowSync } from '../../services/workflowService';
import toastService from '../../services/toastService';

const RecommendationCards = ({ recommendations = [], workbenchData ={}}) => {
  const [loadingStates, setLoadingStates] = useState({});
  
  // Sort recommendations by rank (ascending)
  const sortedRecommendations = [...recommendations].sort((a, b) => (a.rank || 0) - (b.rank || 0));
  const basePath = process.env.PUBLIC_URL || '';

  const handleRecommendationSubmit = async (recommendation, index) => {
    // Validate required data
    if (!workbenchData?.manualTask) {
      toastService.error('Missing workflow data');
      return;
    }

    const { manualTask } = workbenchData;
    
    // Set loading state for this specific button
    setLoadingStates(prev => ({ ...prev, [index]: true }));
    // console.log(manualTask)
    try {
      const payload = {
        workflow_cd: manualTask.pipeline_cd,
        resume_workflow_from_step_instance_id: parseInt(manualTask.node_execution_id, 10),
        resume_workflow_from: manualTask.code,
        pipeline_execution_id: manualTask.pipeline_id,
        in_detail_entities: manualTask.in_detail_entities || [],
        session_id:manualTask.session_id,
        user_id:manualTask.user_id,
        selected_action: recommendation
      };

      const response = await executeWorkflowSync(payload);
      toastService.success('Recommendation submitted successfully');
      // console.log('Workflow execution response:', response);
      
      // You can add additional logic here like refreshing data or navigating
    } catch (error) {
      console.error('Error submitting recommendation:', error);
      toastService.error('Failed to submit recommendation');
    } finally {
      setLoadingStates(prev => ({ ...prev, [index]: false }));
    }
  };

  return (
    <div className={styles.recommendationSection}>
      <div className={styles.recommendationHeader}>
        <div className={styles.recommendationTag}>Recommended Decision Paths</div>
      </div>

      <div className={styles.recommendationGrid}>
        {sortedRecommendations.map((rec,index) => {
          // {console.log(rec.primary)}
          const isAI = rec.primary === 1;
          const badgeText = rec.recommendedBadgeText || 'AI Recommended';
          const descriptionContent = rec.description || rec.markdown || 'xsacsasacac';
          
          return (
            <div key={index} className={isAI ? styles.recommendationCardAI : styles.recommendationCardNormal}>
              {isAI && (
                <div className={styles.aiRecommendedBadge}>
            <img src={`${basePath}/assets/images/workbench/ai-star-icon-white.png`} alt="star-icon" style={{ width: '24px', height: '24px' }} />
            {badgeText}
                </div>
              )}
              <div className={`${styles.recommendationContent} ${isAI ? styles.aiContentCard : ''}`}>
                <h4 className={isAI ? styles.recommendationTitleAI : styles.recommendationTitle}>
                  {rec.title}
                </h4>
                <div className={isAI ? styles.recommendationDescriptionAI : styles.recommendationDescription}>
                  <ReactMarkdown>{descriptionContent}</ReactMarkdown>
                </div>

                <div className={isAI ? styles.recommendationPayableAI : styles.recommendationPayable}>
                  <span className={isAI ? styles.recommendationPayableLabelAI : styles.recommendationPayableLabel}>
                    Payable Amount
                  </span>
                  <span className={isAI ? styles.recommendationPayableValueAI : styles.recommendationPayableValue}>
                    {rec.payableAmountText}
                  </span>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <button 
                    className={isAI ? styles.submitButtonAI : styles.submitButtonNormal}
                    onClick={() => handleRecommendationSubmit(rec, index)}
                    disabled={loadingStates[index]}
                  >
                    {/* {loadingStates[index] ? 'Submitting...' : (
                      rec.ctaText && (rec.ctaText.length > 30 || /[<|>]/.test(rec.ctaText)) 
                        ? 'View Recommendation' 
                        : rec.ctaText
                    )} */}
                    {loadingStates[index] ? 'Submitting...' : (
                      rec.ctaText && (rec.ctaText.length > 30 || /[<|>]/.test(rec.ctaText)) 
                        ? 'View Recommendation' 
                        : 'Submit'
                    )}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecommendationCards;
